import { Layout } from "antd";
import PageContent from "../../routes";

const MobileLayout = () => {
  return (
    <Layout id="app" className="mobile-layout">
      <PageContent />
    </Layout>
  );
};

export default MobileLayout;
